class StickNavbar {
    constructor() {
        this.header = document.querySelector(".header-bar");
        this.sideBar = document.querySelector(".navigation-sidebar-wrap");
        this.prevScrollpos = window.pageYOffset + 30;
        this.events();
    }

    events() {
        document.addEventListener("scroll", (e) => {
            if (
                this.prevScrollpos < window.pageYOffset &&
                this.prevScrollpos > 0 &&
                !this.sideBar.classList.contains("open")
            ) {
                this.header.classList.add("hided");
            } else {
                this.header.classList.remove("hided");
            }
            this.prevScrollpos = window.pageYOffset;
        });
        document.addEventListener("scroll", (e) => {
            if (window.pageYOffset > 0) {
                this.header.classList.add("header-bar--sticked");
            } else {
                this.header.classList.remove("header-bar--sticked");
            }
        });
    }
}

export default StickNavbar;
